import React from 'react';
import { useTranslation } from 'react-i18next';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Run({ action, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.PYTHON.RUN.';
    return (
        <>
            <div className="form-element">
                {t(label + 'CHOOSE-SCRIPT')}
                <VariablePicker action={action} inputName="script" variables={variables} setOpenVariable={setOpenVariable} isRequired/>
            </div>
            {/* <div className="form-element">
                {t(label + 'EXECUTED-FUNCTION')}
                <TextInput action={action} inputName="function" variables={variables} setOpenVariable={setOpenVariable}/>
            </div>
            <div className="form-element">
                {t(label + 'PARAMETERS')}
                <VariablePicker action={action} inputName="parameters" variables={variables} setOpenVariable={setOpenVariable}/>
            </div> */}
            <div className="form-element">
                {t(label + 'ASSIGN')}
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable} isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
        </>
    );
}
export default Run;